import { WORKSPACES } from "../../lib/site";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORKSPACES.map((w, i) => (
      <span key={w.slug} className="flex items-center">
        <span className={`font-display px-8 text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tight ${i % 2 ? "text-outline-soft" : "text-white"}`}>
          {w.name}
        </span>
        <svg viewBox="0 0 20 20" className="h-5 w-5 sm:h-7 sm:w-7 text-[#D4AF37]" aria-hidden="true"><path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-label="Workspace formats" data-testid="marquee-section" className="relative overflow-hidden border-y border-white/10 bg-[#0B0F17] py-8 sm:py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
